<div class="row">
    <div class="col-12 no-padding">
        <rask-tree-selector
            aid="filterHeaderGeografiItems"
            class="col-3"
            [placeholder]="texts.geografiplaceholder"
            [label]="texts.geografi"
            (change)="setGeografiItemsFromSelector()"
            [items]="geografiItems"
            [required]="false"></rask-tree-selector>

        <rask-tree-selector
            aid="filterHeaderAvverkningstypItems"
            class="col-2"
            [placeholder]="texts.avverkningstypplaceholder"
            [label]="texts.avverkningstyp"
            (change)="setAvverkningstypFromSelector()"
            [items]="avverkningstypItems"
            [required]="false"></rask-tree-selector>

        <rask-input
            aid="filterHeaderSearchFilterBeteckning"
            class="col-2"
            [placeholder]="texts.fritextsokplaceholder"
            [label]="texts.fritextsok"
            [(ngModel)]="searchFilter.beteckning"></rask-input>

        <rask-tree-selector
            aid="filterHeaderAnskaffningsformItems"
            class="col-2"
            [placeholder]="texts.anskaffningsformplaceholder"
            [label]="texts.anskaffningsform"
            (change)="setAnskaffningsformFromSelector()"
            [items]="anskaffningsformItems"
            [required]="false"></rask-tree-selector>
        <rask-tree-selector
            aid="filterHeaderAffarsformItems"
            class="col-3"
            [placeholder]="texts.affarsformformplaceholder"
            [label]="texts.affarsform"
            (change)="setAnskaffningsformFromSelector()"
            [items]="affarsformItems"
            [disabled]="!canUseAffarsform()"
            [required]="false"></rask-tree-selector>
    </div>
</div>